/** @jsxImportSource @emotion/react */
"use client";

import { useTranslations } from "@i18n/react";
import { SPEEDS, usePlayerSpeedIndex } from "@packages/media";
import { ModalTab, SpeedIcon } from "@packages/ui";

import type { MediaMenuTabProps } from "../MediaMenu.emotion";

export const SelectPlaybackSpeedTab = ({ disabled }: MediaMenuTabProps) => {
  const { currentIdx } = usePlayerSpeedIndex();
  const t = useTranslations();

  return (
    <ModalTab
      key={"speedSelectMenuTab"}
      value={"speedSelectMenu"}
      label={t("track_settings_playback_speed")}
      startIcon={<SpeedIcon />}
      disabled={disabled}
    >
      {t("web_audio_player_speed", { "0": SPEEDS[currentIdx] })}
    </ModalTab>
  );
};
